export default "__VITE_ASSET__B_ge6rrh__"